function setRem(designWidth) {
    var width = window.innerWidth;
    var scale = width / designWidth * 14
    document.documentElement.style.fontSize = `${scale}px`
}

window.addEventListener('resize', function () {
    setRem(1920)
})

window.addEventListener("pageshow", function () {
    setRem(1920)
})


// WEBPACK FOOTER //
// ./src/utils/rem.js